import React from 'react';
import $ from "jquery";
import Header from '../modules/header'
import axios from 'axios';

import Footerslider from '../components/FooterSlider/footerslider';
import motoryatch from '../assets/images/Home/Motor yachts.png';
import saillingyatch from '../assets/images/Home/Sailing yachts.png';
import openyatch from '../assets/images/Home/Open yachts.png';
import Catamarans from '../assets/images/Home/Catamarans.png';
import Subtract from '../assets/images/Home/Subtract.png';
import guletsyatch from '../assets/images/Home/Gulet tachts.png';
import filter from '../assets/images/icons/filter-icon.png';
import cardbg1 from '../assets/images/icons/card-bg2.png';
import close from '../assets/images/icons/close-icon.png';
import arrowbtn from '../assets/images/icons/Arrow.png';
import refresh from '../assets/images/icons/refresh.png';
import cardbg2 from '../assets/images/icons/card-bg1.png';
import { Link } from "react-router-dom";

import Card from './card'
class Search extends React.Component {

  constructor(props) {
    super(props);
    let searchCategory = localStorage.getItem('searchCategory');
    this.state = {
      registry_ports: [],
      flags: [],
      types: [],
      sailing_regions: [],
      tags: [],
      features: [],
      toys: [],
      category: searchCategory || '',
      type_id: this.props.location.type_id ? this.props.location.type_id : 0,
      tag_id: this.props.location.tag_id ? this.props.location.tag_id : 0,
      registry_port_id: 0,
      flag_id: 0,
      min_price: '',
      max_price: '',
      min_length: '',
      max_length: '',
      build_year: '',
      refit_year: '',
      must_cabins: '',
      cabins: '',
      passengers: '',
      accommodation: '',
      feature_ids: [],
      sailing_ids: [],
      toy_ids: [],
      search_text: this.props.location.search_text ? this.props.location.search_text : '',
      yachts: [],
      featured_types: [],
      total_count: 0,
      total_pages: 0,
      current_page: 0,
      next_page: 1,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFeatureChange = this.handleFeatureChange.bind(this);
    this.handleSailingChange = this.handleSailingChange.bind(this);
    this.handleToyChange = this.handleToyChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleType = this.handleType.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
    localStorage.removeItem('searchCategory');
  }

  handleType(event) {
    const type_id = event.target.attributes["data-type-id"].value;
    this.setState({ type_id: type_id });
    this.submitForm(null, type_id);
  }

  handlePagination(event) {
    this.submitForm(null, null, this.state.next_page);
  }

  handleSearchChange(event) {
    this.setState({ search_text: event.target.value });
    if (event.target.value.length > 2 || event.target.value.length === 0) {
      this.submitForm(event.target.value);
    }
  }

  handleFeatureChange(event) {
    const checked = event.target.checked;
    const name = event.target.name;
    if (checked) {
      if (!this.state.feature_ids.includes(name)) {
        var ids = this.state.feature_ids;
        ids.push(name);
        this.setState({ feature_ids: ids });
      }
    }
    else {
      const ids = this.state.feature_ids.filter(function (ele) {
        return ele !== name;
      });
      this.setState({ feature_ids: ids });
    }

  }

  handleSailingChange(event) {
    const checked = event.target.checked;
    const name = event.target.name;
    if (checked) {
      if (!this.state.sailing_ids.includes(name)) {
        var ids = this.state.sailing_ids;
        ids.push(name);
        this.setState({ sailing_ids: ids });
      }
    }
    else {
      const ids = this.state.sailing_ids.filter(function (ele) {
        return ele !== name;
      });
      this.setState({ sailing_ids: ids });
    }

  }

  handleToyChange(event) {
    const checked = event.target.checked;
    const name = event.target.name;
    if (checked) {
      if (!this.state.toy_ids.includes(name)) {
        var ids = this.state.toy_ids;
        ids.push(name);
        this.setState({ toy_ids: ids });
      }
    }
    else {
      const ids = this.state.toy_ids.filter(function (ele) {
        return ele !== name;
      });
      this.setState({ toy_ids: ids });
    }
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name == 'category') {
      if (value == 'charter') {
        $("#category_label").text("Weekly Charter Rate (EUR)");
        $("#price_box").removeClass('hide');
      }
      else if (value == 'sale') {
        $("#category_label").text("Sale Price (EUR)");
        $("#price_box").removeClass('hide');
      }
      else {
        $("#price_box").addClass('hide');
        $("#min_price").val(0);
        $("#max_price").val(0);
        $("#category_label").text("Price (EUR)");
      }
    }

    if (name == 'accommodation') {
      if (value == '') {
        $("#must_cabins").addClass('hide');
      }
      else {
        $("#must_cabins").removeClass('hide');
      }
    }

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.submitForm();
  }

  searchByCategory(page = 1) {
    const data = {
      category: this.state.category,
      page: page,
      type_id: this.state.type_id,
      tag_id: this.state.tag_id,
      search_text: this.state.search_text
    };

    axios.post(`${process.env.REACT_APP_API_URL}/search/filter_yachts.json`, data)
      .then((response) => {
        console.log(response)
        const data = response.data;
        if (data.current_page === 1) {
          this.setState({ yachts: data.yachts })
        } else {
          this.setState({
            yachts: this.state.yachts.concat(data.yachts)
          })
        }

        this.setState({
          total_count: data.total_count,
          total_pages: data.total_pages,
          current_page: data.current_page,
          next_page: data.next_page
        });
      })
      .catch();
  }

  submitForm(search_text = null, type_id = null, page = 1) {
    const data = {
      category: this.state.category,
      type_id: type_id == null ? this.state.type_id : type_id,
      registry_port_id: this.state.registry_port_id,
      tag_id: this.state.tag_id,
      flag_id: this.state.flag_id,
      min_price: this.state.min_price,
      max_price: this.state.max_price,
      min_length: this.state.min_length,
      max_length: this.state.max_length,
      build_year: this.state.build_year,
      refit_year: this.state.refit_year,
      cabins: this.state.cabins,
      must_cabins: this.state.must_cabins,
      accommodation: this.state.accommodation,
      passengers: this.state.passengers,
      feature_ids: this.state.feature_ids,
      sailing_ids: this.state.sailing_ids,
      toy_ids: this.state.toy_ids,
      search_text: search_text === null ? this.state.search_text : search_text,
      page: page,
    };

    axios.post(`${process.env.REACT_APP_API_URL}/search/filter_yachts.json`, data)
      .then((response) => {
        console.log(response)
        const data = response.data;
        if (data.current_page === 1) {
          this.setState({ yachts: data.yachts })
        } else {
          this.setState({
            yachts: this.state.yachts.concat(data.yachts)
          })
        }

        this.setState({
          total_count: data.total_count,
          total_pages: data.total_pages,
          current_page: data.current_page,
          next_page: data.next_page
        });
      })
      .catch();
  }

  componentDidMount() {
    window.scrollTo(0, 0)

    console.log(this.state.category)

    axios.get(`${process.env.REACT_APP_API_URL}/search.json`)
      .then((response) => {
        this.setState({
          registry_ports: response.data.registry_ports,
          flags: response.data.flags,
          types: response.data.types,
          tags: response.data.tags,
          features: response.data.features,
          toys: response.data.toys,
          featured_types: response.data.featured_types,
          sailing_regions: response.data.sailing_regions,
        });
        window.scrollTo(0, 0)
      })
      .catch();

    this.searchByCategory();

    $(document).ready(function () {
      $('.advance-filter').hide();
      $('.filter-btn').click(function () {
        $('.advance-filter').show("fast");
      });
      $('.close-btn a').click(function () {
        $('.advance-filter').hide("fast");
      });
    });
  }
  render() {
    return (
      <div className="open_menudiv">
        <Header></Header>
        {/* Main Hero Image section  */}

        <div className="hero-slider section search-hero" id="search_page">
          <div className="hero-item" id="generic-header">
            <div className="slider-dark-overlay"></div>
            <div className="container">
              <div className="row">
                <div className="hero-content-wrap col">
                  <div className="hero-content searchpage-content">
                    <div className="slide-txt">
                      <p id="serrch_fline" className="first-line text-center">search yachts and gulets</p>
                      {/* <h1 className="second-line text-center">Luxury yachts for charter</h1> */}
                    </div>
                    <div className="banner-btns searchpage-searchbar">
                      <div className="input-group">
                        <input type="text" className="form-control" placeholder="Type Yacht Name" name="search_text" value={this.state.search_text} onChange={this.handleSearchChange} />
                        <i className="fa fa-search"></i>
                        <span className="input-group-btn">
                          <button className="btn btn-secondary search-btn filter-btn" type="button">Filters</button>
                          <img src={filter} className="img-responsive" alt="filter" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="secondary-menu d-none d-sm-block">
                  <nav className="navbar navbar-expand-lg navbar-dark primary-color">
                    <ul className="navbar-nav mr-auto" id="nav_links_right">
                      {this.state && this.state.featured_types && this.state.featured_types.map((type, index) => {
                        return [
                          <li key={index} className="nav-item">
                            <Link className="nav-link" data-type-id={type.id} onClick={this.handleType}>
                              <img src={motoryatch} className="img-responsive menu-icon" alt="motor yachts" />
                              {type.name}
                            </Link>
                          </li>
                        ]
                      })}

                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* filter advance section */}
        <section id="advance-filter" className="section fix advance-filter">
          <div className="vector_art1">
            <img src={cardbg1} className="img-responsive" alt="cardbg1" />
          </div>
          <div className="close-btn">
            <a href="#"><img src={close} className="img-responsive" alt="close" /></a>
          </div>
          <div className="container">
            <div className="row">
              <div className="heading">
                <h1>Advanced Filters</h1>
                <p></p>
              </div>
            </div>
            <div className="row">
              <div className="filter-form">
                <form onSubmit={this.handleSubmit}>
                  <div className="form-row">
                    <div className="col label-heading">
                      {/* <label>Type Yacht Name</label> */}
                    </div>
                    <div className="row yatch_name col-md-7">
                      <div className="col-lg-4 col-md-4">
                        <select id="inputState" className="form-control" name="category" value={this.state.category} onChange={this.handleChange}>
                          <option value=''>Select Category</option>
                          <option value='charter'>For Charter</option>
                          <option value='sale'>For Sale</option>
                        </select>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <select id="inputState" className="form-control" name="type_id" value={this.state.type_id} onChange={this.handleChange}>
                          <option value="0">Yacht Type</option>
                          {this.state.types.map((type, index) => {
                            return [
                              <option key={index} value={type.id}>{type.name}</option>
                            ]
                          })}
                        </select>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <select id="inputState" className="form-control" name="tag_id" value={this.state.tag_id} onChange={this.handleChange}>
                          <option value="0">Yacht Tag</option>
                          {this.state.tags.map((type, index) => {
                            return [
                              <option key={index} value={type.id}>{type.name}</option>
                            ]
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* <!---- Type Yacht Name ---> */}
                  <div className="form-row prices-row hide" id="price_box">
                    <div className="col label-heading">
                      <label id="category_label">Sale Price (EUR)</label>
                    </div>
                    <div className="row rate_price col-md-7">
                      <div className="col-lg-6 col-md-6 col-6 min-price">
                        <input type="number" className="form-control" id="min_price" placeholder="Min Price" name="min_price" min="0" step="1000" value={this.state.min_price} onChange={this.handleChange} />
                      </div>
                      <div className="col-lg-6 col-md-6 col-6 max-price">
                        <input type="number" className="form-control" id="max_price" placeholder="Max Price" name="max_price" min="0" step="1000" value={this.state.max_price} onChange={this.handleChange} />
                      </div>
                    </div>
                  </div>
                  {/* <!---- Rates Prices ---> */}
                  <div className="form-row" id="specificatin_mob">
                    <div className="col-lg-4 label-heading">
                      <label>Overall Lenght (Meters)</label>
                    </div>
                    <div className="col-lg-8">
                      <div className="row specification">
                        {/* <div className="col-lg-3 col-md-4">
                                                    <input type="number" className="form-control" id="" placeholder="Year build" name="build_year" value={this.state.build_year} onChange={this.handleChange}/>
                                                </div>
                                                <div className="col-lg-3 col-md-4">
                                                    <input type="number" className="form-control" id="" placeholder="Year Re-Fit" name="refit_year" value={this.state.refit_year} onChange={this.handleChange}/>
                                                </div> */}
                        <div className="col-lg-6 col-md-6">
                          <input type="number" className="form-control" id="" placeholder="Length Min" name="min_length" value={this.state.min_length} onChange={this.handleChange} />
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <input type="number" className="form-control" id="" placeholder="Length Max" name="max_length" value={this.state.max_length} onChange={this.handleChange} />
                        </div>
                        {/* <div className="col-lg-4 col-md-4 top-space">
                                                    <select id="inputState" className="form-control" name="registry_port_id" value={this.state.registry_port_id} onChange={this.handleChange}>
                                                    <option value="0">Ports of Registry</option>                                                
                                                    { this.state.registry_ports.map((type, index) => {
                                                        return [
                                                            <option key={index} value={type.id}>{type.name}</option>
                                                        ]
                                                    })}                                    
                                                    </select>
                                                </div>
                                                <div className="col-lg-4 col-md-4 top-space">
                                                <select id="inputState" className="form-control" name="flag_id" value={this.state.flag_id} onChange={this.handleChange}>
                                                    <option value="0">Flags</option>                                                
                                                    { this.state.flags.map((type, index) => {
                                                        return [
                                                            <option key={index} value={type.id}>{type.country_name}</option>
                                                        ]
                                                    })}                                    
                                                    </select>
                                                </div> */}
                      </div>
                    </div>
                  </div>
                  {/* <!----Specifications ----> */}
                  <div className="form-row" id="specificatin_mob">
                    <div className="col-lg-4 label-heading">
                      <label>Accommodations</label>
                    </div>
                    <div className="col-lg-8">
                      <div className="row accomodations-fields">
                        <div className="col-lg-6 col-md-6 col-6 cabins-div">
                          <input type="number" className="form-control cabin" id="" placeholder="Cabins Minimum" min="0" step="1" name="cabins" value={this.state.cabins} onChange={this.handleChange} />
                        </div>
                        <div className="col-lg-6 col-md-4 col-6 passengers-div">
                          <input
                            type="number"
                            className="form-control passenger"
                            id=""
                            placeholder="Passengers Minimum" name="passengers" min="0" step="1" value={this.state.passengers} onChange={this.handleChange} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-row" id="specificatin_mob">
                    <div className="col-lg-4 label-heading">
                      <label>Must Have</label>
                    </div>
                    <div className="col-lg-8">
                      <div className="row accomodations-fields">
                        <div className="col-lg-6 col-md-6">
                          <select id="inputState" name="accommodation" className="form-control" value={this.state.accommodation} onChange={this.handleChange}>
                            <option selected value=''>Cabin Types</option>
                            <option value='master_cabins'>Master Cabin</option>
                            <option value='twin_cabins'>Twin Cabin</option>
                            <option value='single_cabins'>Single Cabin</option>
                            <option value='double_cabins'>Double Cabin</option>
                            <option value='triple_cabins'>Triple Cabin</option>
                            <option value='extra_bunk_beds'>Extra Bunk Beds</option>

                          </select>
                        </div>
                        <div className="col-lg-6 col-md-6 col-6 cabins-div">
                          <input type="number" className="form-control cabin hide" id="must_cabins" placeholder="Minimum" min="0" step="1" name="must_cabins" value={this.state.must_cabins} onChange={this.handleChange} />
                        </div>
                        {/* <div className="col-lg-4 col-md-4 col-6 passengers-div">
                                                    <input
                                                        type="number"
                                                        className="form-control passenger"
                                                        id=""
                                                        placeholder="Passengers" name="passengers" value={this.state.passengers} onChange={this.handleChange}/>
                                                </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="form-row" id="checkboxsnew">
                    <div className="col-lg-4 label-heading">
                      <label>Saling Region</label>
                    </div>
                    <div className="col-lg-8 feature-checkbox">
                      <div className="row">
                        {this.state.sailing_regions.map((type, index) => {
                          return [
                            <div className="col-lg-3 col-md-3 col-6">
                              <div className="form-group">
                                <div className="form-check">
                                  <label className="checkbox-container">
                                    {type.name}
                                    <input type="checkbox" className="form-check-input" name={type.id} value={this.state.sailing_ids.includes(type.id)} onChange={this.handleSailingChange} />
                                    <span className="checkmark"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          ]
                        })}
                      </div>
                    </div>
                  </div>
                  {/* <!---- Accomodations -----> */}
                  <div className="form-row" id="checkboxsnew">
                    <div className="col-lg-4 label-heading">
                      <label>Key Features</label>
                    </div>
                    <div className="col-lg-8 feature-checkbox">
                      <div className="row">
                        {this.state.features.map((type, index) => {
                          return [
                            <div className="col-lg-3 col-md-3 col-6">
                              <div className="form-group">
                                <div className="form-check">
                                  <label className="checkbox-container">
                                    {type.name}
                                    <input type="checkbox" className="form-check-input" name={type.id} value={this.state.feature_ids.includes(type.id)} onChange={this.handleFeatureChange} />
                                    <span className="checkmark"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          ]
                        })}
                      </div>
                    </div>
                  </div>
                  {/* <!----- Key Features -----> */}
                  <div className="form-row" id="checkboxsnew">
                    <div className="col-lg-4 label-heading">
                      <label className="water_toys">Water Toys</label>
                    </div>
                    <div className="col-lg-8 toys-checkbox">
                      <div className="row">
                        {this.state.toys.map((type, index) => {
                          return [
                            <div key={index} className="col-lg-3 col-md-3 col-6">
                              <div className="form-group">
                                <div className="form-check">
                                  <label className="checkbox-container">
                                    {type.name}
                                    <input type="checkbox" className="form-check-input" name={type.id} value={this.state.toy_ids.includes(type.id)} onChange={this.handleToyChange} />
                                    <span className="checkmark"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          ]
                        })}
                      </div>
                    </div>
                  </div>

                  <div className="form-row" id="form_srchbtns">
                    <div className="col-lg-4 label-heading"></div>
                    <div className="col-lg-8">
                      <div className="filter-btns">
                        <button className="btn btn-secondary btn-theme2 filter-search">SEARCH<img src={arrowbtn} alt="arrowbtn" />
                        </button>
                        <button className="btn btn-secondary btn-theme2 filter-autorefresh" onClick={() => { window.location.reload() }}>RESET<img src={refresh} alt="refresh" />
                        </button>
                      </div>
                    </div>

                  </div>

                </form>
              </div>
            </div>
          </div>
          <div className="vector_art2">
            <img src={cardbg2} className="img-responsive" alt="card bg" />
          </div>
        </section>

        {/* second section start */}
        <section id="card-grids" className="section fix cards-grid-section">
          <div className="container-fluid no-padding">
            <div className="portfolio clearfix">
              <div className="list clearfix">
                <Card yachts={this.state.yachts}></Card>
              </div>
            </div>
            {
              this.state && this.state.next_page == null ?
                false
                :
                <div className="load-more-btn-div text-center">
                  <button className="btn btn-secondary load-more-btn" onClick={this.handlePagination}>Show More</button>
                </div>
            }

          </div>
        </section>

        {/* slider section */}
        <Footerslider></Footerslider>
        <a href="#pagetop" id="back-to-top" title="Back to top">&uarr;</a>

      </div>
    );
  }
}
export default Search;